import { withApp } from "@/components/App"
import Slice from "@/settlement/Slice"

import SettlementCard from "./SettlementCard"

export default withApp(SettlementCard, { slices: [Slice] })
